export const CURRENT = 'current';
export const FORMER = 'former';
